import { DARK_BLUE, LIGHTEST_GRAY } from "@120wateraudit/waterworks";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

interface SubnavigationTab {
  label: string;
  to: string;
}

interface SubnavigationTabsProps {
  subnavigationTabs: SubnavigationTab[];
  className?: string;
}

export function SubnavigationTabs(
  props: SubnavigationTabsProps
): React.ReactElement {
  const { subnavigationTabs } = props;

  return (
    <TabsWrapper>
      <TabList>
        {subnavigationTabs.map((tab) => (
          <StyledNavLink key={tab.to} to={tab.to} end>
            {tab.label}
          </StyledNavLink>
        ))}
      </TabList>
    </TabsWrapper>
  );
}

export const TabsWrapper = styled.div`
  border-bottom: 1px solid ${LIGHTEST_GRAY};
`;

export const TabList = styled.div`
  display: flex;
  gap: 24px;
`;

export const StyledNavLink = styled(NavLink)`
  padding-bottom: 8px;
  text-decoration: none;
  color: #374151; // gray-700
  border-bottom: 4px solid transparent;
  font-size: 14px;

  &.active {
    font-weight: 600;
    border-color: ${DARK_BLUE};
    color: black;
  }
`;
